import { Component, OnInit, Input, Output, EventEmitter, Inject, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { ActivityFilter } from 'src/app/core/models/activityFilter';
import { MeetingMode } from 'src/app/core/utils/meeting-mode';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { UserService } from 'src/app/core/services/user.service';
import { RequisitionService } from 'src/app/core/services/requisition.service';
import { EntityActivitiesService } from 'src/app/core/services/entity-activities.service';
import { SharedAjsService } from 'src/app/core/services/shared-ajs.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { JobService } from 'src/app/core/services/job.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { OutreachService } from 'src/app/core/services/outreach.service';

@Component({
  selector: 'app-recent-activities',
  templateUrl: './recent-activities.component.html',
  styleUrls: ['./recent-activities.component.css']
})
export class RecentActivitiesComponent implements OnInit {

  @ViewChild('activityNoLongerMatchReasonsTemplate') activityNoLongerMatchReasonsTemplateRef: TemplateRef<any>;

  @Input() context;
  @Input() candidateId;
  @Input() jobMatchId;
  @Input() userId;
  @Input() requisitionId;
  @Input() isSharedRequisition;
  @Input() recentActivitiesControls;
  @Input() isActivityClicked;
  @Input() activityMap;
  @Output() showAllCallback = new EventEmitter<any>();
  @Output() activitiesLoadedCallback = new EventEmitter<any>();

  showCandidateNoLongerMatchModal: BsModalRef;
  showCandidateOutreachNoResponseModal: BsModalRef;
  showClientReviewAuditModal: BsModalRef;
  
  isLoading: boolean = true;
  isStaffingCompany: boolean = false;
  showClientReviewInfo: boolean = false;
  companyId: any;
  companyName: any;
  activities: any = [];
  count: any;
  noLongerMatchActivityReasons: any = [];
  salaryDurationOptions: any = [];
  jobTypeList: any = [];
  outreachNoResponseJobMatches: any = [];
  clientReviewAuditData: any = null;
  currentActivity: any = null;

  constructor(
    private candidateService: CandidateService,
    public requisitionService: RequisitionService,
    private userService: UserService, 
    private companyService: CompanyService, 
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private activitiesService: EntityActivitiesService,
    @Inject(SharedAjsService) public sharedAjsService: SharedAjsService,
    private bsModalService: BsModalService,
    private jobService: JobService,
    private authService: AuthService,
    private outreachService: OutreachService
    ) { }

  ngOnInit() {
    this.companyId = this.authService.userDetails.company.companyId;
    this.companyName = this.authService.userDetails.company.companyName;
    this.isStaffingCompany = this.authService.getUserDetails().company.companyType === 'Staffing';
    if (!this.activities) {
      this.activities = [];
    }
    if (!this.context) {
      this.context = 'global';
    }
    if (_.isUndefined(this.recentActivitiesControls)) {
      this.recentActivitiesControls = {};
    }
    this.recentActivitiesControls.activityClickCount = 0;
    this.count = 0;
  }

  ngOnChanges(changes) {
    if (this.recentActivitiesControls.activityClickCount > 0) {
      this.isLoading = !this.isLoading ? true : this.isLoading;

      let completedCount = 0;
      const totalFunctions = 3;

      const checkAllCompleted = () => {
        completedCount++;
        if (completedCount === totalFunctions) {
          this.isLoading = false;
        }
      };

      if (this.salaryDurationOptions.length === 0) {
        this.getSalaryDurationOptions(() => checkAllCompleted());
      } else {
        checkAllCompleted();
      }

      if (this.jobTypeList.length === 0) {
        this.getAllPreferredJobTypes(() => checkAllCompleted());
      } else {
        checkAllCompleted();
      }
      
      this.getActivities(() => checkAllCompleted());
    }
    this.recentActivitiesControls.activityClickCount++;
  }

  getActivities(successCallback) {
    let activityFilter = new ActivityFilter();
    activityFilter.companyId = this.companyId;
    activityFilter.page = 1;
    activityFilter.size = 5;
    if (this.context === "candidateCard" || this.context === "candidateJobMatchCard") {
      activityFilter.candidateId = this.candidateId;
      if (this.context === "candidateJobMatchCard") {
        activityFilter.jobMatchId = this.jobMatchId;
      }
      this.activities = [];
      this.candidateService.getCandidateActivities(activityFilter, (data) => {
        angular.forEach(data, (val, key) => {
          val.activityDisplayValue = this.activityMap[val.activityType];
          val.miniStatement = this.activityMap[val.activityType];
          // if it final reminder activity
          if (val.activityMessage) {
            val.activityDisplayValue = val.activityMessage;
            val.miniStatement = val.activityMessage;
          }
          val.createdBy = val.createdBy.trim();
          val.statement = '';

          const outreachEventTypes = [
            "CANDIDATE_OUTREACH_SENT",
            "OUTREACH_COMPLETED",
            "OUTREACH_RESPONSE_REMINDER",
            "OUTREACH_NOT_COMPLETED_REMINDER",
            "OUTREACH_RESPONSE_EXPIRED",
            "OUTREACH_COMPLETION_EXPIRED",
            "OUTREACH_COMPLETION_REMINDER"
          ];

          if (outreachEventTypes.includes(val.activityType)) {
            let contextType: String = this.context === "candidateCard" ? 'candidate' : 'candidateJobMatchCard';
            val.activityDisplayValue = this.activitiesService.setOutreachNoResponseActivityDetails(val, contextType, this.context);
            let includeCreatedBy = ['CANDIDATE_OUTREACH_SENT'];
            val.activityDisplayValue = includeCreatedBy.includes(val.activityType) ? val.activityDisplayValue + " by " + "<span class='emerald'>" + val.createdBy + "</span>" : val.activityDisplayValue;
            let removeCreatedBy = ['OUTREACH_COMPLETED', 'OUTREACH_RESPONSE_REMINDER', 'OUTREACH_NOT_COMPLETED_REMINDER', 'OUTREACH_RESPONSE_EXPIRED', 'OUTREACH_COMPLETION_EXPIRED', 'OUTREACH_COMPLETION_REMINDER'];
            val.createdBy = removeCreatedBy.includes(val.activityType) ? '' : val.createdBy;
          }

          if (val.activityType.includes('CLIENT_REVIEW_RESPONSE_RECEIVED') || val.activityType.includes('CLIENT_REVIEW_SENT')) {
            val.activityDisplayValue = this.activitiesService.formatClientReviewAuditDetails(val);
            if (val.clientReviewAuditDetails) {
              // Check if information was sent to client for review (check parsed blob)
              let sentToClientForReview = false;
              if (val.clientReviewAuditDetails.informationSentBlob) {
                try {
                  const blobData = typeof val.clientReviewAuditDetails.informationSentBlob === 'string'
                    ? JSON.parse(val.clientReviewAuditDetails.informationSentBlob)
                    : val.clientReviewAuditDetails.informationSentBlob;
                  sentToClientForReview = blobData.sentToClientForReview === true;
                } catch (e) {
                  sentToClientForReview = false;
                }
              }

              if (sentToClientForReview) {
                val.showClientReviewAuditDetails = true;
                val.clientReviewAuditData = this.activitiesService.prepareClientReviewAuditData(val.clientReviewAuditDetails);
              }

            }
          }

          // if (outreachEventTypes.includes(val.activityType)) {
          //   val.activityDisplayValue = this.activitiesService._getHighlightedNotificationHTML(val.toState);
          //   if (val.candidateOutreachJobMatchesInfo && val.candidateOutreachJobMatchesInfo.jobMatches && val.candidateOutreachJobMatchesInfo.jobMatches.length > 0) {
          //     val.showOutreachNoResponseIcon = true;
          //     val.candidateOutreachJobMatchesInfo.jobMatches.forEach(jobMatch => {
          //       this.outreachService.setCompanyLocationLabel(jobMatch, this.isStaffingCompany);
          //       jobMatch.missingOrNonMatched = this.outreachService.setMissedOrMatchedInfo(jobMatch.missingOrNonMatchedInfo, jobMatch.workLocations);
          //       jobMatch.formattedOutreachStatus = this.outreachService.formatOutreachStatus(jobMatch.outreachStatus);
          //       jobMatch.jobDetails = this.outreachService.setJobDetailsLabel(jobMatch, this.jobTypeList, this.salaryDurationOptions);
          //       jobMatch.daysSinceOutreach = this.outreachService.setDaysSinceOutreach(jobMatch);
          //       jobMatch.candidateMatch = this.outreachService.setCandidateMatchingLabel(jobMatch);
          //     });
          //   }
          // }

          if (val.activityType.includes('CANDIDATE_NO_LONGER_MATCHES')) {
            val.activityDisplayValue = this.activitiesService._getHighlightedNotificationHTML(val.toState);
            if (val.reasons && val.reasons.length > 0) {
              val.showNoLongerMatchResults = true;
              val.reasons = this.activitiesService.setActivityReasons(val);
            }
          }

          if (val.activityType.includes('CANDIDATE_OUTREACH_UPLOAD') || val.activityType.includes('CANDIDATE_RESUME_UPLOAD')) {
            val.activityDisplayValue = val.toState + " by <span class='emerald'>" + val.createdBy + "</span>";
          }

          if (val.activityType.includes('RE_RUN_SCORE')) {
            if (val.fromState && val.toState && (val.fromState === val.toState)) {
              val.miniStatement = "Score remains unchanged"
              val.activityDisplayValue = val.miniStatement + " at '<span class='emerald'>" + (val.fromState ? val.fromState : val.toState) + "</span>'";
            } else {
              val.miniStatement = "Score has changed"
              val.activityDisplayValue = val.miniStatement + " from '<span class='emerald'>" + val.fromState + "</span>' to '<span class='emerald'>" + val.toState + "</span>'";
            }
            if (val.title && val.title != '' && val.requisitionNumber && val.requisitionNumber != '' && this.context === "candidateCard") {
              val.activityDisplayValue = val.activityDisplayValue + " for '<span class='emerald'>" + val.title + ' (' + val.requisitionNumber + ')' + "</span>'";
            }
          }
          if(val.activityType.includes("DOCUMENT")) {
            val.activityDisplayValue = val.miniStatement + "<span> by " + val.createdBy + "</span>";
            val.isDocumentEmailActivity = false;
            if(val.activityType == 'DOCUMENT_EMAILED' || val.activityType == 'DOCUMENT_FAILED') {
              if(val.listOfDocumentsSent || val.listOfUsersDocumentsSent) {
                val.isDocumentEmailActivity = true;
              }
            }
            val.activityType = 'document';
          }
          if (val.activityType.includes("CHANGED") || val.activityType.includes("STATE_CHANGE")) {
            if (_.isNull(val.toState)) {
              val.toState = "-";
            }
            if (val.activityType.includes("CANDIDATE_NAME_CHANGED")
              || val.activityType.includes("CANDIDATE_PHONE_NUMBER_CHANGED")
              || val.activityType.includes("CANDIDATE_EMAIL_CHANGED")
              || val.activityType.includes("CANDIDATE_LOCATION_CHANGED")
              || val.activityType.includes("CANDIDATE_SALARY_CHANGED")
              || val.activityType.includes("CANDIDATE_SPONSORSHIP_CHANGED")
              || val.activityType.includes("CANDIDATE_RELOCATION_CHANGED")
              || val.activityType.includes("CANDIDATE_SPONSORSHIP_NOTE_CHANGED")
              || val.activityType.includes("CANDIDATE_RELOCATION_NOTE_CHANGED")
              || val.activityType.includes("CANDIDATE_WORK_LOCATION_CHANGED")) {
              val.activityDisplayValue = val.miniStatement + " from '<span class='emerald'>" + val.fromState + "</span>' to '<span class='emerald'>" + val.toState + "</span>'";
            }
            val.activityType = 'change';
            if (val.fromState.includes("Assessment") || val.toState.includes("Assessment")) {
              val.activityDisplayValue = "Assessment Status Changed to <span class='emerald'>" + val.toState + "'</span> for the role <span class='emerald'>'" + val.title + "'</span>";
            }
            else if (val.fromState.includes("Phone Screen") || val.toState.includes("Phone Screen")) {
              val.activityDisplayValue = "Phone Screen Status Changed to <span class='emerald'>" + val.toState + "'</span> for the role <span class='emerald'>'" + val.title + "'</span>";
            } else if (val.fromState.includes("Interview") || val.toState.includes("Interview")) {
              val.activityDisplayValue = "Interview Status Changed to <span class='emerald'>" + val.toState + "'</span> for the role <span class='emerald'>'" + val.title + "'</span>";
            }
          }
          if (val.activityType.includes("STEP_CHANGE")) {
            val.activityType = 'change';
            val.activityDisplayValue = "Candidate Moved to <span class='emerald'>'" + val.toState + "'</span> for the role <span class='emerald'>'" + val.title + "'</span>" + " with Job ID <span class='emerald'>'" + val.requisitionNumber + "'</span>";
          } else if (val.activityType.includes("ADDED") || (val.activityType.includes("REMINDER") && !val.activityType.includes("OUTREACH") ) || val.activityType.includes("COMMUNICATION")) {
            if (val.activityType.includes("CANDIDATE_NAME_ADDED")
              || val.activityType.includes("CANDIDATE_PHONE_NUMBER_ADDED")
              || val.activityType.includes("CANDIDATE_EMAIL_ADDED")
              || val.activityType.includes("CANDIDATE_LOCATION_ADDED")
              || val.activityType.includes("CANDIDATE_SALARY_ADDED")
              || val.activityType.includes("CANDIDATE_SPONSORSHIP_ADDED")
              || val.activityType.includes("CANDIDATE_RELOCATION_ADDED")
              || val.activityType.includes("CANDIDATE_SPONSORSHIP_NOTE_ADDED")
              || val.activityType.includes("CANDIDATE_RELOCATION_NOTE_ADDED")
              || val.activityType.includes("CANDIDATE_WORK_LOCATION_ADDED")) {
              val.activityType = 'add';
              val.activityDisplayValue = val.activityDisplayValue + " '<span class='emerald'>" + val.toState + "</span>'";
            } else {
              val.activityType = 'add';
              if (val.meetingMode) {
                val.activityDisplayValue = `${val.activityDisplayValue} via <b>${MeetingMode[val.meetingMode]}</b>`;
              }
              val.activityDisplayValue = `${val.activityDisplayValue} for the role <span class='emerald'>'${val.title}'</span> with Job ID <span class='emerald'>'${val.requisitionNumber}'</span>`;
              if (val.count) {
                val.activityDisplayValue = val.count + " " + val.activityDisplayValue;
              }
            }
          } else if (val.activityType.includes("ASSIGNED")) {
            val.activityType = 'assign';
            val.activityDisplayValue = val.activityDisplayValue + " for the role <span class='emerald'>'" + val.title + "'</span>" + " with Job ID <span class='emerald'>'" + val.requisitionNumber + "'</span>";
          } else if (val.activityType.includes("REMOVED") || val.activityType.includes("DELETED")) {
            val.activityType = 'remove';
            val.activityDisplayValue = val.activityDisplayValue + " for the role <span class='emerald'>'" + val.title + "'</span>" + " with Job ID <span class='emerald'>'" + val.requisitionNumber + "'</span>";
          } else if (val.activityType.includes("PHONE_SCREEN") || val.activityType.includes("INTERVIEW")) {
            const via = val.meetingMode == null ? "" : ` via <b>${MeetingMode[val.meetingMode]}</b>`;
            val.activityDisplayValue = `${val.activityDisplayValue} ${via} for the role <span class='emerald'>'${val.title}'</span>`;
          }
          // if meeting count exists and its not the final reminder activity
          if (val.meetingCount && _.isNull(val.activityMessage)) {
            val.activityDisplayValue = val.meetingCount + " " + val.activityDisplayValue;
          }
          val.activityDisplayValue = val.activityDisplayValue.replace("Candidate Note", "Note");
          val.activityDisplayValue = val.activityDisplayValue.replace("Matched Candidate Recruiter", "Recruiter");
          val.activityDisplayValue = val.activityDisplayValue.replace("Candidate Communications", "Communication");
          if (val.clientOrBuName && val.activityType != 'document') {
            val.activityDisplayValue = val.activityDisplayValue + " for <span class='emerald'>'" + val.clientOrBuName + "'</span>";
            if (val.jobLocation) {
              let jobLocationText = this.companyService.getParsedCompanyLocationText(val.jobLocation, true);
              val.activityDisplayValue = val.activityDisplayValue + jobLocationText;
            }
          }

          val.activityDisplayValue = val.activityDisplayValue.replace("Matched Candidate State Changed", "Candidate State Changed");
          if (val.reasonNote && val.reasonNote.length > 0) {
            val.activityDisplayValue = val.activityDisplayValue + "<br><b>Reason: </b>" + val.reasonNote;
          }
          val.notesDisplay = "";
          if (val.note && val.note.length > 0) {
            // if(this.isSharedRequisition) {
            val.notesDisplay = "<b>Internal Note: </b><br>" + this._replaceSpecialCharacters(val.note) + "<br>";
            // } else {
            //     val.notesDisplay = "<b>Note: </b>" + candidateJobMatch.jobMatchCurrentStateInternalNote + "<br>"; 
            // }
          }
          if (val.externalNote && val.externalNote.length > 0) {
            val.notesDisplay = val.notesDisplay + "<b>External Note: </b><br>" + this._replaceSpecialCharacters(val.externalNote);
          }
          val.displayDate = new Date(val.date);
          val.showShortMessageFlag = true;
          this.activities.push(val)
        });
          if (successCallback) {
          successCallback();
        }
        if (this.activitiesLoadedCallback) {
          this.activitiesLoadedCallback.emit();
        }
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    } else if (this.context === "requisitionCard") {
      let requisitionInfo = { isSharedRequisition: this.isSharedRequisition, currentCompanyName: this.companyName };
      this.requisitionService.getRequisitionActivity(this.requisitionId, 1, 5, (data) => {
        this.activities = this.activitiesService.getMassagedActivities(data, this.activityMap, 'requisition', requisitionInfo, this.isStaffingCompany, this.jobTypeList, this.salaryDurationOptions);
        for (let val of this.activities) {
          val.activityDisplayValue = val.activityDisplayValue + val.mainText;
          if (val.reasonNote && val.reasonNote.length > 0) {
            val.activityDisplayValue = val.activityDisplayValue + "<br><b>Reason: </b>" + val.reasonNote;
          }
          val.notesDisplay = "";
          if (val.note && val.note.length > 0) {
            val.notesDisplay = "<b>Internal Note: </b><br>" + this._replaceSpecialCharacters(val.note) + "<br>";
          }
          if (val.externalNote && val.externalNote.length > 0) {
            val.notesDisplay = val.notesDisplay + "<b>External Note: </b><br>" + this._replaceSpecialCharacters(val.externalNote);
          }
          val.displayDate = new Date(val.date);
          val.showShortMessageFlag = true;
        }
          if (successCallback) {
          successCallback();
        }
        if (this.activitiesLoadedCallback) {
          this.activitiesLoadedCallback.emit()
        }
      }, (error) => {
        // do nothing
      });
    } else if (this.context === "userCard" || this.context === "employeeCard") {
      activityFilter.userId = this.userId;
      this.activities = [];
      this.userService.getUserActivities(activityFilter, (data) => {
        this.activities = this.activitiesService.getMassagedActivities(data, this.activityMap, this.context, null, this.isStaffingCompany, this.jobTypeList, this.salaryDurationOptions);
        for (let val of this.activities) {
          val.activityDisplayValue = val.activityDisplayValue + val.mainText;
          if (val.reasonNote && val.reasonNote.length > 0) {
            val.activityDisplayValue = val.activityDisplayValue + "<br><b>Reason: </b>" + val.reasonNote;
          }
          val.notesDisplay = "";
          if (val.note && val.note.length > 0) {
            val.notesDisplay = "<b>Internal Note: </b><br>" + this._replaceSpecialCharacters(val.note) + "<br>";
          }
          if (val.externalNote && val.externalNote.length > 0) {
            val.notesDisplay = val.notesDisplay + "<b>External Note: </b><br>" + this._replaceSpecialCharacters(val.externalNote);
          }
          val.displayDate = new Date(val.date);
          val.showShortMessageFlag = true;
        }
          if (successCallback) {
          successCallback();
        }
        if (this.activitiesLoadedCallback) {
          this.activitiesLoadedCallback.emit()
        }
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  _replaceSpecialCharacters(text) {
    let replacedText = text;
    for (let i = 0; i < replacedText.length; i++) {
      replacedText = replacedText.replace('<', '&lt;').replace('>', '&gt;');
    }
    replacedText = replacedText.replace(/&lt;br&gt;/g, '<br>');
    return replacedText;
  }

  expandText($event, activity) {
    activity.showShortMessageFlag = !activity.showShortMessageFlag;
    $event.stopPropagation();
    setTimeout(() => {
      if (this.jobMatchId) {
        document.getElementById(this.jobMatchId + '-activity-dropdown-menu').scrollIntoView({behavior: 'smooth', block: 'end'})
      }
    }, 200);
  }

  showAllActivity() {
    if (this.showAllCallback) {
      this.showAllCallback.emit();
    }
  }

  goToCandidateDocuments(activity) {
    let actionType = 'emailNotification';
    let actionLabel = 'Details of Documents Emailed';
    let documentDtoMap = {
      listOfDocumentsSent: activity.listOfDocumentsSent,
      listOfUsersDocumentsSent: activity.listOfUsersDocumentsSent
    }
    this.sharedAjsService.goToCandidateDocuments(actionType, actionLabel, documentDtoMap);
  }

  goToCandidateNoLongerMatchReasons(template: TemplateRef<any>, activity) {
    this.noLongerMatchActivityReasons = activity.reasons;
    const config = new ModalConfig();
    const modalData: any = {};
    config.class = "modal-lg custom-ngx-modal";
    config.initialState = modalData;
    this.showCandidateNoLongerMatchModal = this.bsModalService.show(template, config);
  }

  goToCandidateOutreachNoResponseModal(template: TemplateRef<any>, activity) {
    this.outreachNoResponseJobMatches = activity.candidateOutreachJobMatchesInfo.jobMatches;
    const config = new ModalConfig();
    const modalData: any = {};
    config.class = "modal-lg custom-ngx-modal";
    config.initialState = modalData;
    this.showCandidateOutreachNoResponseModal = this.bsModalService.show(template, config);
  }

  goToClientReviewAuditModal(template: TemplateRef<any>, activity) {
    this.clientReviewAuditData = activity.clientReviewAuditData;
    this.showClientReviewInfo = false;
    this.currentActivity = activity;
    const config = new ModalConfig();
    const modalData: any = {};
    config.class = "modal-lg custom-ngx-modal";
    config.initialState = modalData;
    this.showClientReviewAuditModal = this.bsModalService.show(template, config);
  }

  getSalaryDurationOptions(successCallback) {
    this.jobService.getSalaryDurationOptions((data) => {
      this.salaryDurationOptions = data;
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllPreferredJobTypes(successCallback) {
    this.jobService.getAllJobTypes((data) => {
      this.jobTypeList = data;
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  toggleClientReviewInfoModal() {
    this.showClientReviewInfo = !this.showClientReviewInfo;
  }

}
